var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h4", [_vm._v("Materiais de Divulgação")]),
      _vm._v(" "),
      _c(
        "b-card",
        [
          _c("b-table", {
            attrs: {
              items: _vm.lista,
              fields: _vm.fields,
              striped: "",
              bordered: "",
              "show-empty": "",
              small: ""
            },
            scopedSlots: _vm._u([
              {
                key: "cell(actions)",
                fn: function(row) {
                  return [
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "primary", size: "sm" },
                        on: { click: row.toggleDetails }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              row.detailsShowing ? "Esconder" : "Mostrar"
                            ) +
                            " Detalhes\n        "
                        )
                      ]
                    )
                  ]
                }
              },
              {
                key: "row-details",
                fn: function(row) {
                  return [
                    _c(
                      "b-row",
                      { staticClass: "justify-content-md-center" },
                      [
                        _c(
                          "b-col",
                          {
                            staticClass: "col-md-10",
                            attrs: { "align-self": "center" }
                          },
                          [
                            _c(
                              "b-card",
                              {
                                staticClass: "p-3 mb-3",
                                attrs: {
                                  "bg-variant": "dark",
                                  "text-variant": "white"
                                }
                              },
                              [
                                _c(
                                  "b-container",
                                  { attrs: { fluid: "" } },
                                  [
                                    _c("b-row", [
                                      _c("b", [_vm._v("Descrição:")]),
                                      _vm._v(
                                        "   " +
                                          _vm._s(row.item.descricao) +
                                          "\n                "
                                      )
                                    ]),
                                    _vm._v(" "),
                                    row.item.tipo === "VIDEO"
                                      ? _c("b-row", [
                                          _c("b", [_vm._v("Link do Video:  ")]),
                                          _vm._v("    "),
                                          _c(
                                            "a",
                                            {
                                              staticStyle: { color: "white" },
                                              attrs: { href: row.item.path }
                                            },
                                            [
                                              _vm._v(
                                                "  " +
                                                  _vm._s(row.item.path) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    row.item.tipo === "VIDEO"
                                      ? _c(
                                          "b-row",
                                          {
                                            staticClass: "text-center",
                                            attrs: { "align-v": "center" }
                                          },
                                          [
                                            _c(
                                              "b-col",
                                              {
                                                staticClass: "mt-2 col-md-12",
                                                attrs: {
                                                  "align-self": "center"
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  [
                                                    _c("b-embed", {
                                                      attrs: {
                                                        type: "iframe",
                                                        aspect: "21by9",
                                                        src: row.item.path,
                                                        allowfullscreen: ""
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      : _c(
                                          "b-row",
                                          { staticClass: "mt-2" },
                                          [
                                            _c(
                                              "b-button",
                                              {
                                                attrs: {
                                                  size: "sm",
                                                  variant: "warning"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.download(
                                                      row.item.id
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "fas fa-eye"
                                                }),
                                                _vm._v(" Visualizar Arquivo")
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a04e4fd", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a04e4fd","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/material_divulgacao/List.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-1a04e4fd","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/material_divulgacao/List.vue
// module chunks = 2